import type { SystemRole } from "@/lib/system-roles";
import { useUser } from "@/lib/user-context";

export type { SystemRole } from "@/lib/system-roles";

export function useSystemRole() {
  const { systemRole, isSystemRoleLoading, isSessionLoading, hasPermission } =
    useUser();

  const isLoading = isSystemRoleLoading || isSessionLoading;

  return {
    systemRole,
    isLoading,
    error: null,
    isWorker: systemRole === "worker",
    isSiteManager: systemRole === "site_manager",
    isAdmin: systemRole === "admin",
    hasPermission,
  };
}

export function useRequireRole(requiredRole: SystemRole) {
  const { systemRole, isLoading, hasPermission } = useSystemRole();

  return {
    hasAccess: !isLoading && hasPermission(requiredRole),
    isLoading,
    systemRole,
    requiredRole,
  };
}

export function useRequireSiteManager() {
  return useRequireRole("site_manager");
}

export function useRequireAdmin() {
  return useRequireRole("admin");
}
